import { loadPreferences, myPreferences } from '@/appLogic/view/preferences';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { TableType } from '@/coreDomainsModule/table';

/**
 * 保持したフィルター情報を取得する
 */
export class GetTableFilterPreferenceUseCase {
  /**
   * 指定したテーブルタイプのフィルター情報を取得する
   * @param tableType - テーブルの種類
   * @returns - filterTypeをkeyとしたフィルターのリスト
   */
  public async execute(tableType: TableType): Promise<INetworkResult<{ [key: string]: string[] }, Error>> {
    try {
      await loadPreferences();
      if (!myPreferences) {
        return {
          status: {
            type: 'error',
            error: Error('preferenceの取得に失敗しました'),
          },
        };
      }
      if (!Object.keys(myPreferences).includes(tableType) || !myPreferences[tableType].filterInfos) {
        return {
          status: {
            type: 'error',
            error: Error('指定したtableTypeのフィルター情報が存在しません'),
          },
        };
      }
      return {
        status: {
          type: 'success',
          data: myPreferences[tableType].filterInfos,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('取得に失敗しました'),
        },
      };
    }
  }
}
